import { render, staticRenderFns } from "./SlideoutHeader.vue?vue&type=template&id=071423c7"
import script from "./SlideoutHeader.vue?vue&type=script&lang=js"
export * from "./SlideoutHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports